export enum TokenType {
  Application,
  User,
}

export type Token = {
  token: string
  type: TokenType
}
